import ArticleRow from "@/components/ArticleRow"
import PressRow from "@/components/PressRow"
import SectionHeading from "@/components/SectionHeading"
import { createDataAttribute } from "next-sanity"

interface ArticleFeedProps {
  articles: any
	heading?: string
	documentId: string
	_key: string
}

export default function ArticleFeed({articles, heading = "Latest News", documentId, _key}:ArticleFeedProps) {
  return (
    <div className="section px-site"
			key={_key}
			data-sanity={createDataAttribute({
				id: documentId,
				type: 'project',
				path: `contentBlocks[_key=="${_key}"]`,
			}).toString()}>

			<div className="mb-section--sm sm:text-center">
				<SectionHeading heading={heading || `Latest News`} label="View More" url="/news" />
			</div>

			<div className="article-list relative">

				{articles?.slice(0, 4)?.map((article, index) => (
					article?._type === "press" ? (
						<PressRow
							key={`${article.slug}-${index}`}
							headline={article?.title}
							date={article?.publishedDate}
							url={article?.url}
							image={article?.image}
						/>
					) : (
						<ArticleRow
							key={`${article.slug}-${index}`}
							headline={article?.title}
							tag={article?.tag?.title}
							date={article?.publishedDate}
							url={article?._type === "press" ? article?.url : `/news/${article?.slug}`}
							image={article?.image}
						/>
					)
				))}

			</div>

		</div>
	)
}